import type { HTMLAttributes, JSX } from 'react'
import { iconsAvailable, type IconName } from './iconsAvailable'
import { cn } from '@/utilities/misc'

type Props = HTMLAttributes<HTMLSpanElement> & {
  icon: IconName
  className?: string
}

export function Icon({
  icon,
  className,
  ...rest
}: Props) {

  const TheIcon = iconFactory.get(icon)

  if (!TheIcon) {
    console.error(`Icon not found: ${icon}`)
    return <div>[{icon}]</div>
  }

  return (
    <TheIcon
      className={cn('Icon', className)}
      {...rest}
    />
  )
}


export type IconProps = HTMLAttributes<HTMLSpanElement> 

const iconFactory = new Map<IconName, (props: IconProps) => JSX.Element>()

Object.entries(iconsAvailable).forEach(([key, svgMarkup]) => {
  const svgComponent = (props: IconProps) => (
    <span
      data-icon={key}
      {...props}
      style={{ display: 'inline-flex', ...props.style }}
      dangerouslySetInnerHTML={{ __html: svgMarkup }}
    />
  )
  iconFactory.set(key as IconName, svgComponent)
})
